window.$ = window.jQuery;

export default class OrticaMaps {
	static mapVersion = "";

  constructor(configs) {
    this.mapControls = {
      zoomControl: true,
      mapTypeControl: true,
      scaleControl: true,
      streetViewControl: true,
      rotateControl: true,
      fullscreenControl: true,
		};

		this.currentPage = 0;
		this.forPage = 5;
		this.style = [];
		
		this.markerImg = {
	//   url: "https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi-dotless2.png",
        url: "/wp-content/themes/ortica/src/images/icons/marker.svg",
      // This marker is 20 pixels wide by 32 pixels high.
      size: new google.maps.Size(32, 32),
      // The origin for this image is (0, 0).
      origin: new google.maps.Point(0, 0),
      // The anchor for this image is the base of the flagpole at (0, 32).
      anchor: new google.maps.Point(0, 43),
    };

		this.markers = [];
		this.mapHasPosition = false;
		this.setConfiguration(configs);
	}

  static load() {
		const script = document.getElementById("google-maps-script");
		const maps = $(`#map--${this.mapVersion} .map`).data("maps");
		
		return new Promise((resolve, reject) => {
			if (!document.querySelector(`#map--${this.mapVersion} .map`)) {
        return reject(`Map version ${this.mapVersion} is not present on dom`);
      }	

			script.onload = resolve.bind(this, {mapVersion: this.mapVersion, ...maps});
			script.onerror = reject
		});
	}
	

  setConfiguration(configs) {
		this.forPage = +configs.for_page;
		this.mapVersion = configs.mapVersion
    this.position = configs.position
      ? { lat: +configs.position.lat, lng: +configs.position.lng }
			: null;
		this.mapHasPosition = !!this.position; 
    this.zoom = +configs.zoom || 8;
		this.locations = configs.locations;

		return this;
  }

  maybeCenterMap() {
    return this.position && this.position.lat && this.position.lng ? { center: this.position } : {};
  }

  setMapControls(controls = {}) {
    this.mapControls =  {
      ...this.mapControls,
      ...controls,
		};

		return this;
  }

  getMapControls() {
    return this.mapControls;
	}
	
	setMarkers() {
		this.markers = this.locations.map((location, i) => {
			const marker = new google.maps.Marker({
        position: { lat: +location.marker.lat, lng: +location.marker.lng },
        label: String(i + 1),
        title: location.shop.name,
        icon: this.markerImg,
      });	


			if (location.marker.content) {
				const infowindow = new google.maps.InfoWindow({
          content: location.marker.content,
          // disableAutoPan: true,
				});
				
				marker.addListener("click", () => {
					this.map.panTo(marker.getPosition());
					infowindow.open(this.map, marker)
				});
			}

			return marker;
		})	

		$(`#map__markers--${this.mapVersion}`).on("click", this.goToPosition.bind(this));
		return this;
	}

	goToPosition(e) {
		const className = "map__marker";
		let marker;
		if ($(e.target).hasClass(className)) {
			marker = $(e.target);
		} else {
			marker = $(e.target).parents(`.${className}`);
		}

		if (marker.length <= 0) return;

		const coordinate = marker.data("coordinate");

		if (!coordinate) return
		
		this.map.panTo({
      lat: +coordinate.lat,
      lng: +coordinate.lng,
    });
	}

	getMarkers() {
		return this.markers;
	}

	aggregateMarkers () {
		this.markerClusterer = new MarkerClusterer(this.map, this.markers, {
    	imagePath: "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
		});

		return this;
	}

	attachMarkersToMap() {
		this.markers.map(marker => marker.setMap(this.map))
		
		return this;
	}

	setMarkerImg(image) {
		this.markerImg = image;
	}

	centerMapByMarker() {
		if (this.locations.length <= 0) return this;

		this.bounds = new google.maps.LatLngBounds();
		
		this.locations.forEach((location) => {
	    this.bounds.extend({ lat: +location.marker.lat, lng: +location.marker.lng });
	  });

	  // Case: Single marker.
	  if (this.locations.length == 1) {
	    this.map.setCenter(this.bounds.getCenter());
	    // Case: Multiple markers.
	  } else if (this.locations.length > 1) {
	    this.map.fitBounds(this.bounds);
		}
		
		return this;
	}

	maybeHandleBasicPagination() {
		this.paginatePrev = $(`#map--${this.mapVersion} .map__paginate-prev`);
		this.paginateNext = $(`#map--${this.mapVersion} .map__paginate-next`);

		this.paginatePrev.on("click", () => {
			const oldCurrentPage = this.currentPage;
		
			if (this.currentPage > 0) {
				this.currentPage -= this.forPage;
			}

      if (this.currentPage <= 0) { 
				this.currentPage = 0;
				this.paginatePrev.addClass("map__paginate-prev--disable");
			}

			if (this.currentPage === oldCurrentPage) return;

			this.paginateNext.removeClass("map__paginate-next--disable");

      this.renderMarkerList.call(this, "back");
    });
		
		this.paginateNext.on("click", () => {
			const oldCurrentPage = this.currentPage;

			if (this.currentPage + this.forPage >= this.locations.length) return;

			this.paginateNext.removeClass("map__paginate-next--disable");
			this.paginatePrev.removeClass("map__paginate-prev--disable");

			this.currentPage = this.currentPage + this.forPage <=( this.locations.length -1 ) ? this.currentPage + this.forPage : (this.locations.length -1) 
		
			if (this.currentPage === oldCurrentPage) return;

			if (this.currentPage + this.forPage >= this.locations.length ) {
				this.paginateNext.addClass("map__paginate-next--disable");
			}
			
      this.renderMarkerList.call(this, 'next');
    });

		return this;
	}

	renderMarkerList(direction) {
		const html = this.locations
      .slice(this.currentPage, (this.currentPage + this.forPage))
      .map(this.markup.bind(this));

		
		$(`#map__markers--${this.mapVersion}`)
		.animate({
			opacity: 0
		}, 300, () => {
			$(`#map__markers--${this.mapVersion}`)
			.html(html.join(""))
			.animate({ opacity: 1 }, 300);
		})
	}

	attachSearchBar() {
		this.input = document.getElementById("pac-input");
		this.searchBox = new google.maps.places.SearchBox(this.input);
		this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(this.input);

		this.map.addListener("bounds_changed", () => {
      this.searchBox.setBounds(this.map.getBounds());
		});
		
		this.searchMarkers = [];

		// Listen for the event fired when the user selects a prediction and retrieve
		// more details for that place.
		this.searchBox.addListener("places_changed", this.handleSearchBoxPlaceChanged.bind(this));

		return this;
	}

	handleSearchBoxPlaceChanged() {
		const places = this.searchBox.getPlaces();

		if (places.length == 0) return;
		
		// Clear out the old markers.
		this.searchMarkers.forEach((marker) => { marker.setMap(null) });

		this.searchMarkers = [];
		// For each place, get the icon, name and location.
		const bounds = new google.maps.LatLngBounds();
		
		places.forEach((place) => {
			if (!place.geometry) {
				console.log("Returned place contains no geometry");
				return;
			}

			// const icon = {
			// 	url: place.icon,
			// 	size: new google.maps.Size(71, 71),
			// 	origin: new google.maps.Point(0, 0),
			// 	anchor: new google.maps.Point(17, 34),
			// 	scaledSize: new google.maps.Size(25, 25),
			// };

			// Create a marker for each place.
			// this.searchMarkers.push(
      //   new google.maps.Marker({
      //     map: this.map,
      //     icon,
      //     title: place.name,
      //     position: place.geometry.location,
      //   })
      // );

			if (place.geometry.viewport) {
				// Only geocodes have viewport.
				bounds.union(place.geometry.viewport);
			} else {
				bounds.extend(place.geometry.location);
			}
		});

		this.map.fitBounds(bounds);
	}

	setStyle(style) {
		this.style = style
		return this;
	}

	getStyle() {
		return this.style;
	}

  renderMap() {
    this.map = new google.maps.Map(
      document.querySelector(`#map--${this.mapVersion} .map`),
      {
        zoom: this.zoom,
        ...this.maybeCenterMap(),
				...this.getMapControls(),
				styles: this.getStyle()
      }
    );

		return this;
  }
}
